import React, { useEffect, useRef } from 'react';

/**
 * Nested modal for editing full product description (keeps newlines).
 * Renders above the bulk-create modal (z-index 1060+).
 */
const BulkCreateDescriptionModal = ({
  show,
  value,
  productLabel,
  loading,
  onChange,
  onClose
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!show) return undefined;
    const t = window.setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        const len = textareaRef.current.value.length;
        textareaRef.current.setSelectionRange(len, len);
      }
    }, 50);
    return () => window.clearTimeout(t);
  }, [show]);

  useEffect(() => {
    if (!show) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <>
      <div
        className="modal-backdrop show"
        style={{ zIndex: 1060 }}
        onClick={onClose}
      />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1070 }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-scrollable"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header py-2">
              <h5 className="modal-title mb-0">
                Опис товару
                {productLabel ? (
                  <span className="text-muted font-weight-normal ml-2" style={{ fontSize: '0.9rem' }}>
                    {productLabel}
                  </span>
                ) : null}
              </h5>
              <button type="button" className="close" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <textarea
                ref={textareaRef}
                className="form-control"
                rows={16}
                value={value || ''}
                placeholder="Введіть повну комплектацію / опис товару"
                disabled={loading}
                onChange={e => onChange(e.target.value)}
                style={{ fontFamily: 'inherit', whiteSpace: 'pre-wrap' }}
              />
            </div>
            <div className="modal-footer py-2">
              <button type="button" className="btn btn-primary btn-sm" onClick={onClose}>
                Готово
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkCreateDescriptionModal;
